module.exports = __webpack_public_path__ + "img/Icons-09.833a27e9.png";